import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import styles from './reports.module.scss';
import { Box, Divider, Grid, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/FormControl/Icon';
import Button from '../../components/FormControl/Button';
import React from 'react';
import { ReportService } from '../../services/api';
import { SReports, SReportsGroups } from './types';
import { ACCESS_CONTROLS, UserAccessControlData } from '../../utils/accessControl';

const isDisabled = (cardTitle: string) =>
  !!UserAccessControlData.get(ACCESS_CONTROLS['Reports'][cardTitle]?.[0]['name']);

const Reports = () => {
  const [reportColumns, setReportColumns] = React.useState<SReportsGroups[]>([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    ReportService.getReportPage()
      .then((response) => {
        const responseData = response.data.data.items;
        setReportColumns(responseData);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        // setIsDataLoading(false);
      });
  }, []);

  const handleGenerateReportClick = () => {
    navigate('generated-report');
  };

  return (
    <Box className={styles.container}>
      <Box>
        <div className={styles.generatedReportBtn}>
          <Button
            variant={'contained'}
            text={'Generated Report'}
            disableRipple={true}
            onClick={handleGenerateReportClick}
          />
        </div>
        {reportColumns.map((section: SReportsGroups, index: number) =>
          section.reports && section.reports.length > 0 ? (
            <Box key={index} className={styles.box}>
              <Typography variant='h2' className={styles.title}>
                <Icon size='1.3rem' icon={'ri-file-chart-line'} />
                {section['title']}
              </Typography>
              <Divider className={styles.divide} />
              <Grid container spacing={2}>
                {section.reports.map((items: SReports, index: number) => (
                  <Grid key={index} item xs={3} className={styles.grid}>
                    <Card
                      className={`${styles.card} ${
                        isDisabled(items.name) ? styles.disabledCard : ''
                      }`}
                      onClick={(e) =>
                        isDisabled(items.name)
                          ? e.preventDefault
                          : navigate(`/report/${items.id.replace(/_/g, '-')}`)
                      }
                    >
                      <CardContent className={styles.cardContent}>
                        <Typography gutterBottom variant='h5' component='div'>
                          {items.name}
                        </Typography>
                        <Typography fontSize={'12px'} variant='body2' color='text.secondary'>
                          {items.description}
                        </Typography>
                      </CardContent>
                      <Stack className={styles.background}>
                        <Icon icon='ri-arrow-right-line' className={styles.arrowIcon} />
                      </Stack>
                      {isDisabled(items.name) && (
                        <Stack className={styles.lockIconContainer}>
                          <Icon size='4rem' icon='ri-lock-fill' className={styles.lockIcon} />
                        </Stack>
                      )}
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : null,
        )}
      </Box>
    </Box>
  );
};

export default Reports;
